module.exports = "/assets/data/c79206cd911de4821539f0d3b76af206-LA8.data.json";